import clsx from "clsx"
import {PageProps} from "gatsby"
import React, {useContext, useEffect, useState} from "react"
import TransitionContext from "~/contexts/TransitionContext"
import "~/styles/style.css"
import "~/styles/typography.css"
import I18nContext from "../contexts/I18nContext"
import "./Layout.css"
import {default as NavBar} from "./NavBar/NavBar"
import NavMenu from "./NavMenu/NavMenu"
import Footer from "./Sections/Footer/Footer"
import FacebookPixel from "./UI/FacebookPixel/FacebookPixel"
import CookieSolution from "./UI/Iubenda/CookieSolution"
import LinkedInInsightTag from "./UI/LinkedInInsightTag/LinkedInInsightTag"
import WelcomePopup from "./UI/WelcomePopup/WelcomePopup"
import TagManager from "./UI/TagManager/TagManager"

const url_redirect = "https://value-network.adkaora.com/"

const getLocalStorage = (key: string): string | null => {
    try {
        if (typeof window !== "undefined") {
            return localStorage.getItem(key)
        }
    } catch (error) {
        console.error("Error getting localStorage:", error)
    }
    return null
}

interface LayoutProps extends React.HTMLAttributes<HTMLDivElement>, Omit<PageProps, "children"> {
    history?: History | undefined
}

const Layout: React.FC<LayoutProps> = props => {
    const {
        className,
        children,
        serverData,
        data,
        location,
        pageContext,
        pageResources,
        params,
        path,
        uri,
        ...otherProps
    } = props
    const [menuVisible, setMenuVisible] = useState(false)
    const transitionContenxt = useContext(TransitionContext)
    const {setLanguage} = useContext(I18nContext)

    const showMenu = () => {
        setMenuVisible(true)
    }

    const hideMenu = () => {
        setMenuVisible(false)
    }

    const handleWelcomeChoice = (choice: "yes" | "no") => {
        console.log("User made choice:", choice)
        // You can add additional logic here based on the user's choice
    }

    useEffect(() => {
        if (!transitionContenxt.isLoading) setMenuVisible(false)
    }, [transitionContenxt.isLoading])

    // Check welcome preferences on component mount
    useEffect(() => {
        const welcomeChoice = getLocalStorage("welcome-popup-choice")
        console.log("Welcome choice from localStorage:", welcomeChoice)
        // localStorage.removeItem("welcome-popup-choice")
        if (welcomeChoice === "yes") {
            console.log("User previously chose 'yes', redirecting to publisher site")
            // window.location.href = url_redirect
            window.open(url_redirect, "_blank")
        }
    }, [])

    let currentLanguage: "it" | "en" = "en" // Default to English
    let pathLanguage
    if (typeof window === "undefined") {
        pathLanguage = location.pathname.split("/").at(1) ?? process.env.DEFAULT_LANGUAGE
        // Ensure the language is either "it" or "en"
        currentLanguage = pathLanguage === "it" || pathLanguage === "en" ? pathLanguage : "en"
        console.log("Current language set to:", currentLanguage)
        setLanguage(currentLanguage)
    } else {
        pathLanguage = window.location.pathname.split("/").at(1)
    }

    return (
        <div className={clsx("layout-6jam", className)} {...otherProps}>
            {/* <BackToTop /> */}
            <TagManager />
            <FacebookPixel />
            <LinkedInInsightTag />
            <NavMenu visible={!transitionContenxt.isLoading && menuVisible} onClose={hideMenu} />
            <NavBar onMenuIconClick={showMenu} language={currentLanguage} pathLanguage={pathLanguage} />
            {children}
            <Footer />
            <CookieSolution />
        </div>
    )
}

export default Layout
